<div class="h-100">
  <lib-ph-bhp-observe-protocol-observationHeading [totalNumberOfObservations]="totalNumberOfObservations"
    [sessionName]="sessionName" [selectedward]="selectedward" [selecteddept]="selecteddept" [modalRef]="modalRef"
    [startDateTime]="startDateTime" [endDateTime]="endDateTime" [totalQuota]="totalQuota" [quotaStartDateTime]="quotaStartDateTime"
    [quotaEndDateTime]="quotaEndDateTime"  [quotaDaysLeft]="quotaDaysLeft" [observedQuota]="observedQuota" [quotaId]="quotaId" [numberOfDays]="numberOfDays">
  </lib-ph-bhp-observe-protocol-observationHeading>
  <div class="mt-4 flexDirectionColumn bgGray p-0">
    <div class="observations-content bgGray m-0 image-container-fixedsize justify-content-md-start justify-content-center"
      style="position: relative;">
      <div class=" observeLeft mbp-0">
        <div class=" mbm-0">
          <div class="col-12 categoryUlTabContain" data-simplebar>
            <ul class="categoryUlTab mbm-0">
              <li class="observation-li" *ngFor="let observeCategory of observeDetails.observeCategorys; let i = index">
                <hr class="historic-sep" *ngIf="i != 0">
                <div class="observation-item justify-content-between" [ngClass]="{'active' : (i==activeIndex) }" (click)="showindication=true;getSession(i);">
                  
                  <div class="item-left justify-content-starts p-0">
                    <div class="professional-title font16">{{observeCategory.professsionalCategoryName | translate}}</div>
                    <label class="professional-label">{{(observeCategory.professionalSubCategoryTranslation || observeCategory.professionalSubCategoryName) | translate}}</label>
                  </div>

                  <div class="item-right justify-content-end align-items-center p-0">
                    <div class="complianceDiv d-flex justify-content-end align-items-center m-0">
                      <span class="complianceNum">{{observeCategory.positveCompliance}}</span> <span
                        class="usedQuotaSeperator">/</span>
                      <span class="">{{observeCategory.numberOfObservations}}</span>
                    </div>
                    <label class="subprofessional-label justify-content-center align-items-center ">{{ translationKeys.Dashboard.Opportunities | translate }}</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="d-flex observeRight IEp-0 mbp-0"
        [ngClass]="{'active' : observeRightTab }">

        <div class="col-12 p-0 h-100" *ngIf="showindication">
          <div class="col-12 mt-1 p-0 h-100">
            <tabset class="feedbackTab d-block h-100">
              <tab heading="{{'DASHBOARD.COMPLIANCE' | translate}}" class="chart-div mt-4 w-50">
                <div class="d-flex justify-content-between mb-3 px-2">
                  <div class="tab-title font16">{{ translationKeys.Dashboard.Compliance | translate}}</div>
                </div>
                <div class="">
                  <div class="row">
                    <div class="col-12 px-4">
                      <lib-ph-bhp-bar-chart #chart [hideLegend]="true" [majorUnit]="25"></lib-ph-bhp-bar-chart>
                    </div>
                  </div>
                </div>
              </tab>
              <tab heading="{{'CONFIGURE.OBSERVATION' | translate}}" class="mt-3">
                <lib-ph-bhp-observe-protocol-observationList [observations]="observations">
                </lib-ph-bhp-observe-protocol-observationList>
              </tab>
            </tabset>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
